import PropTypes from 'prop-types';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// @mui
// import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { SMSLogoIcon } from './SMSLogo';
import { getHomePath } from '../routes/paths';
import Image from './Image';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ size = 64, disabledLink = false, sx }) {
  const { pathname } = useLocation()

  const logo = (
    <Box sx={{ width: size, height: size, display: 'flex', justifyContent: 'center', ...sx, }}>
      <Image src='/logo/logo_icon.png' />
    </Box>
  )

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to={getHomePath(pathname)}>{logo}</RouterLink>;
}
